(function () {
  const STAR = '★';

  function formatScore(score) {
    const num = parseFloat(String(score).replace(',', '.'));
    if (Number.isNaN(num)) return null;
    return num.toFixed(1).replace('.', ',');
  }

  function formatDateFr(raw) {
    if (!raw) return '';
    const value = String(raw).trim();
    const us = value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (us) {
      const date = new Date(Number(us[3]), Number(us[1]) - 1, Number(us[2]));
      if (!Number.isNaN(date.getTime())) {
        return new Intl.DateTimeFormat('fr-FR', {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        }).format(date);
      }
    }
    const iso = new Date(value.includes('T') ? value : `${value}T12:00:00`);
    if (!Number.isNaN(iso.getTime())) {
      return new Intl.DateTimeFormat('fr-FR', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }).format(iso);
    }
    return value;
  }

  function normalizeKey(review) {
    return `${(review.body || '').replace(/\s+/g, ' ').trim().toLowerCase()}|${(review.name || '')
      .trim()
      .toLowerCase()}`;
  }

  function formatSummary(root) {
    const custom = root.querySelector('[data-judgeme-summary]');
    const jdgmSummary = root.querySelector('.mcp-judgeme-home__jdgm-summary, .jdgm-all-reviews-text');
    if (!custom) return;

    const score =
      jdgmSummary?.querySelector('.jdgm-all-reviews-rating')?.getAttribute('data-score') ||
      jdgmSummary?.querySelector('.jdgm-all-reviews-rating')?.getAttribute('aria-label')?.match(/[\d.,]+/)?.[0];

    // Toujours le total officiel Judge.me (metafield boutique), jamais le nb de cartes carrousel
    const count =
      jdgmSummary?.querySelector('[data-number-of-reviews]')?.getAttribute('data-number-of-reviews') ||
      jdgmSummary?.querySelector('.jdgm-all-reviews-text')?.textContent?.match(/\d+/)?.[0];

    const formattedScore = formatScore(score);
    if (!formattedScore || !count) return;

    custom.innerHTML = `
      <span class="mcp-judgeme-home__rating">
        <span class="mcp-judgeme-home__stars" aria-hidden="true">${STAR.repeat(5)}</span>
        <span class="mcp-judgeme-home__score"><strong>${formattedScore}</strong><span class="mcp-judgeme-home__score-out">/5</span></span>
        <span class="mcp-judgeme-home__sep" aria-hidden="true"></span>
        <span class="mcp-judgeme-home__count">${count} avis</span>
      </span>
    `;
    jdgmSummary?.classList.add('is-formatted');
  }

  function extractFromCarousel(source) {
    return Array.from(source.querySelectorAll('.jdgm-carousel-item'))
      .map((item) => {
        const rating = item.querySelectorAll('.jdgm-star.jdgm--on').length || 5;
        const title = (item.querySelector('.jdgm-carousel-item__review-title')?.textContent || '').trim();
        const body = (item.querySelector('.jdgm-carousel-item__review-body')?.textContent || '').trim();
        const name = (item.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent || '').trim();
        const dateRaw =
          item.querySelector('.jdgm-carousel-item__timestamp')?.getAttribute('data-time') ||
          item.querySelector('.jdgm-carousel-item__timestamp')?.textContent ||
          '';
        if (!body && !title) return null;
        return {
          rating,
          title,
          body,
          name: name.split(/\s+/)[0] || name,
          date: formatDateFr(dateRaw),
          sortDate: dateRaw,
        };
      })
      .filter(Boolean);
  }

  function extractFromJson(payload) {
    const list = Array.isArray(payload) ? payload : payload?.reviews;
    if (!Array.isArray(list)) return [];
    return list
      .map((item) => {
        const body = (item.body || item.content || '').trim();
        const title = (item.title || '').trim();
        if (!body && !title) return null;
        return {
          rating: Number(item.rating) || 5,
          title,
          body,
          name: String(item.author || item.name || 'Client')
            .trim()
            .split(/\s+/)[0],
          date: formatDateFr(item.date || item.created_at || ''),
          sortDate: item.date || item.created_at || '',
        };
      })
      .filter(Boolean);
  }

  function mergeReviews(...groups) {
    const map = new Map();
    groups.flat().forEach((review) => {
      const key = normalizeKey(review);
      if (!key || key === '|') return;
      if (!map.has(key)) map.set(key, review);
    });
    return Array.from(map.values()).sort((a, b) => {
      const da = Date.parse(a.sortDate || '') || 0;
      const db = Date.parse(b.sortDate || '') || 0;
      return db - da;
    });
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderCards(track, reviews) {
    track.innerHTML = reviews
      .map(
        (review) => `
      <article class="mcp-judgeme-home__card">
        <div class="mcp-judgeme-home__card-stars" aria-hidden="true">${STAR.repeat(Math.max(1, Math.min(5, review.rating)))}</div>
        ${review.title ? `<h3 class="mcp-judgeme-home__card-title">${escapeHtml(review.title)}</h3>` : ''}
        <p class="mcp-judgeme-home__card-body">${escapeHtml(review.body)}</p>
        <div class="mcp-judgeme-home__card-meta">
          ${review.name ? `<div class="mcp-judgeme-home__card-name">${escapeHtml(review.name)}</div>` : ''}
          ${review.date ? `<div class="mcp-judgeme-home__card-date">${escapeHtml(review.date)}</div>` : ''}
        </div>
      </article>
    `
      )
      .join('');
  }

  function setupSlider(root, track, reviews) {
    const slider = root.querySelector('[data-mcp-slider]');
    const nav = root.querySelector('[data-mcp-nav]');
    const prev = root.querySelector('[data-mcp-prev]');
    const next = root.querySelector('[data-mcp-next]');
    if (!slider || !track || reviews.length < 1) return;

    let index = 0;
    let paused = false;
    const intervalMs = parseInt(root.dataset.carouselInterval || '4000', 10);

    const perView = () => (window.matchMedia('(min-width: 750px)').matches ? Math.min(3, reviews.length) : 1);
    const maxIndex = () => Math.max(0, reviews.length - perView());

    const updateCardWidths = () => {
      const cards = Array.from(track.children);
      const isDesktop = window.matchMedia('(min-width: 750px)').matches;
      const gap = isDesktop ? 18 : 14;
      const visible = perView();
      const viewport = slider.clientWidth;
      const width = Math.max(240, Math.floor((viewport - gap * (visible - 1)) / visible));
      cards.forEach((card) => {
        card.style.flex = `0 0 ${width}px`;
        card.style.width = `${width}px`;
        card.style.maxWidth = `${width}px`;
        card.style.minWidth = `${width}px`;
      });
      track.style.gap = `${gap}px`;
      return width + gap;
    };

    const goTo = (nextIndex) => {
      const max = maxIndex();
      index = ((nextIndex % (max + 1)) + (max + 1)) % (max + 1);
      const step = updateCardWidths();
      track.style.transform = `translate3d(-${index * step}px, 0, 0)`;
    };

    if (nav && reviews.length > 1) nav.hidden = false;

    prev?.addEventListener('click', () => goTo(index - 1));
    next?.addEventListener('click', () => goTo(index + 1));

    slider.addEventListener('mouseenter', () => {
      paused = true;
    });
    slider.addEventListener('mouseleave', () => {
      paused = false;
    });
    slider.addEventListener(
      'touchstart',
      () => {
        paused = true;
      },
      { passive: true }
    );
    slider.addEventListener('touchend', () => {
      window.setTimeout(() => {
        paused = false;
      }, 2200);
    });

    window.addEventListener('resize', () => goTo(Math.min(index, maxIndex())));
    goTo(0);

    if (reviews.length > 1) {
      window.setInterval(() => {
        if (paused || document.hidden) return;
        goTo(index + 1);
      }, intervalMs);
    }
  }

  async function loadJsonReviews(root) {
    const url = root.dataset.reviewsUrl;
    if (!url) return [];
    try {
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) return [];
      return extractFromJson(await response.json());
    } catch (error) {
      return [];
    }
  }

  async function setupHome(root) {
    if (root.dataset.homeReviewsReady === 'true') return;

    const source = root.querySelector('[data-judgeme-source]');
    const track = root.querySelector('[data-mcp-track]');
    if (!track) return;

    const carouselReviews = source ? extractFromCarousel(source) : [];
    if (!carouselReviews.length && !root.dataset.reviewsUrl) return;

    // Lock early to avoid duplicate async inits; unlock if empty
    root.dataset.homeReviewsReady = 'pending';

    const jsonReviews = await loadJsonReviews(root);
    const reviews = mergeReviews(carouselReviews, jsonReviews);

    if (!reviews.length) {
      delete root.dataset.homeReviewsReady;
      return;
    }

    formatSummary(root);
    renderCards(track, reviews);
    setupSlider(root, track, reviews);
    root.dataset.homeReviewsReady = 'true';
  }

  function processRoot(root) {
    if (root.classList.contains('mcp-judgeme-home')) {
      setupHome(root);
      return;
    }

    root.querySelectorAll('.jdgm-rev__author, .jdgm-rev__author-wrapper').forEach((author) => {
      const part = (author.textContent || '').trim().split(/\s+/)[0];
      if (part) author.textContent = part;
    });
  }

  function init() {
    document.querySelectorAll('[data-mcp-judgeme]').forEach(processRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('judgeme:loaded', init);

  let attempts = 0;
  const poll = window.setInterval(() => {
    init();
    attempts += 1;
    if (attempts > 40) window.clearInterval(poll);
  }, 300);
})();
